import React from 'react';

const ReparentDropIndicator = ({ isVisible, draggedNode, targetNode, position }) => {
  if (!isVisible || !draggedNode || !targetNode) return null;

  const draggedLabel = (draggedNode.text || 'Untitled idea').trim();
  const targetLabel = (targetNode.text || 'Untitled idea').trim();

  return (
    <div
      data-testid="reparent-drop-indicator"
      role="status"
      aria-label={`Release to move ${draggedLabel} under ${targetLabel}`}
      title={`Release to make this a child of ${targetLabel}`}
      style={{
        position: 'absolute',
        left: position.x,
        top: position.y,
        width: 36,
        height: 36,
        transform: 'translate(-50%, -100%)',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#ffffff',
        background: 'linear-gradient(135deg, #2563eb, #06b6d4)',
        border: '2px solid rgba(255,255,255,0.92)',
        boxShadow: '0 6px 18px rgba(0,0,0,0.35)',
        pointerEvents: 'none',
        zIndex: 1000,
      }}
    >
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="5" r="2.5" fill="currentColor" />
        <circle cx="7" cy="19" r="2.5" fill="currentColor" />
        <circle cx="17" cy="19" r="2.5" fill="currentColor" />
        <path
          d="M12 7.5v4.25M7 16.5v-2.25c0-1.38 1.12-2.5 2.5-2.5h5c1.38 0 2.5 1.12 2.5 2.5v2.25"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default ReparentDropIndicator;
